<template>
  <div>
    <h1>Login</h1>

    <ValidationObserver
      v-slot="{ invalid, passes }"
      ref="loginFormObserver"
      tag="div">
      <el-form
        v-loading="loading"
        ref="loginForm"
        :model="form"
        label-position="top"
        novalidate
        @submit.native.prevent="passes(() => handleForm('loginFormObserver'))"
      >
        <form-alerts :messages="invalidMsg"/>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="rules.email"
          name="E-mail"
          vid="email"
          slim>
          <el-form-item
            :error="errors[0]"
            :required="checkRequired(rules.email)"
            label="E-mail">
            <el-input
              v-model="form.email"
              type="email"
              name="email"/>
          </el-form-item>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="rules.password"
          name="Password"
          vid="password"
          slim>
          <el-form-item
            :error="errors[0]"
            :required="checkRequired(rules.password)"
            label="Password">
            <PasswordField
              id="password"
              v-model="form.password"
              name="password"/>
          </el-form-item>
        </ValidationProvider>

        <el-form-item>
          <el-button
            native-type="submit"
            type="primary">Login
          </el-button>
        </el-form-item>
      </el-form>
    </ValidationObserver>

    <hr>

    <router-link
      :to="{name: 'auth.reset'}"
      class="el-button el-button--text">Forgotten password?
    </router-link>
  </div>
</template>

<script>
  import forms from '@/shared/mixins/forms'
  import { postRequest } from '@/shared/utils/http'
  import PasswordField from '@/shared/components/PasswordField'
  import { rules } from './validation'

  export default {

    components: {
      PasswordField
    },

    mixins: [
      forms
    ],

    data: () => {
      return {
        rules,
        form: {
          email: '',
          password: ''
        }
      }
    },

    methods: {
      submitForm: function () {
        return new Promise((resolve, reject) => {
          postRequest('/login', this.form)
            .then(response => {
              if (response.auth === 'true') {
                window.location = response.intended
              }
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/auth/pages/auth/Login.vue